import { BASE_URL_DIRECT, isLocalDevApiStack } from '../baseUrl';
import styles from './LocalDevEnvironmentBanner.module.css';

/** Shown only during local `npm start` when `.env` points at `/dev-api` (not stable hosted API). */
export function LocalDevEnvironmentBanner() {
  if (!isLocalDevApiStack()) {
    return null;
  }

  return (
    <div className={styles.banner} role="status">
      Local dev → {BASE_URL_DIRECT} (dev stack 3100–3110). dev.offizz.ai uses stable API 3000–3010.
    </div>
  );
}
